var React = require('react');

function ClipInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.15943 13.8283L16.8766 5.22831C17.9351 4.18496 19.6558 4.18496 20.7143 5.22831C21.7728 6.27256 21.7728 7.97103 20.7143 9.01528L8.72124 20.6927C6.9544 22.4358 4.09198 22.4358 2.32513 20.6927C0.558289 18.9505 0.558289 16.1248 2.32513 14.3826L14.1888 2.83011C16.6622 0.389963 20.6736 0.389963 23.1434 2.83011C25.6186 5.27115 25.6186 9.22502 23.1452 11.6652L14.5574 20.1384","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round"}));
}

ClipInline.defaultProps = {"viewBox":"0 0 26 23","fill":"none"};

module.exports = ClipInline;

ClipInline.default = ClipInline;
